import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import {
  LuUsers,
  LuHeart,
  LuLightbulb,
  LuShieldCheck,
  LuHandshake,
} from "react-icons/lu";

import ideologyImg from "../assets/img/mission-image.png";

import "../assets/css/Ideology.css";

const values = [
  {
    icon: <LuUsers />,
    title: "Customer Focus",
    text: "Our purpose in business is to serve our customers and exceed their expectations. We organize every part of the business around their evolving needs so they get unmatched service every time.",
  },
  {
    icon: <LuUsers />,
    title: "People First",
    text: "Our people are our most prized asset not a cliché. We see them as individuals with real value to create, and we build a working environment that lets them grow and thrive holistically.",
  },
  {
    icon: <LuHeart />,
    title: "Passion",
    text: "We love what we do, and we do it with spirit. Our culture is defined by passionate, excellence-driven people who go the extra mile to solve problems and create real value.",
  },
  {
    icon: <LuLightbulb />,
    title: "Creativity",
    text: "We believe in imagination and curiosity and value the diversity of perspectives everyone brings. That mindset drives us to keep seeking new and better ways of getting things done.",
  },
  {
    icon: <LuShieldCheck />,
    title: "Integrity",
    text: "Integrity goes beyond honesty; it is authenticity. Every intention, action and interaction is underpinned by trust. You can count on us. We keep our word.",
  },
  {
    icon: <LuHandshake />,
    title: "Collaboration",
    text: "Isolation is counter-productive. We place a premium on the different talents, resources, and perspectives different parties bring to the table because working together mitigates our weaknesses, and we achieve more.",
  },
];

const Ideology = () => {
  const [, setShow] = useState(false);
  return (
    <>
      <Navbar />

      <section id="ideology">
        <div className="container">
          {/* Intro */}
          <div className="ideology-header">
            <div>
              <span className="ideology-tag">IDEOLOGY</span>

              <h1>
                What we believe, not just
                <br />
                what we say.
              </h1>
            </div>

            <p>
              At the heart of our organization are our mission, vision, and core
              values. They don't just define what we believe, they shape how we
              work, how we serve our clients, and how we create lasting impact.
            </p>
          </div>

          {/* Mission Vision */}
          <div className="mission-grid">
            <div className="mission-image">
              <img src={ideologyImg} alt="Outcess Team" />
            </div>

            <div className="mission-cards">
              <div className="mission-card">
                <h3>Our Mission</h3>
                <p>
                  Inspire and empower people, teams and organizations to do more
                  faster leveraging technology
                </p>
              </div>

              <div className="vision-card">
                <h3>Our Vision</h3>
                <p>
                  To become the African innovation leader in the delivery of
                  digital services globally
                </p>
              </div>
            </div>
          </div>

          {/* Values */}
          <section className="values-section">
            <div className="values-content">
              <h2>Our Values</h2>

              <p>
                Our values are more than aspirations—they are the principles
                that guide every decision we make, from how we build our teams
                to how we support our clients during their most critical
                moments.
              </p>
            </div>

            <div className="values-grid">
              {values.map((item, index) => (
                <div className="value-card" key={index}>
                  <div className="value-icon">{item.icon}</div>

                  <div>
                    <p>{item.text}</p>
                  </div>

                  <div className="value-footer">{item.title}</div>
                </div>
              ))}
            </div>
          </section>
        </div>
        {/* CTA */}
        <section className="ideology-cta">
          <h2>If this sounds like how you'd want to work, we should talk.</h2>

          <p>Find out how these values show up in an actual engagement.</p>

          <button className="ccsnl-btn" onClick={() => setShow(true)}>
            Get In Touch
          </button>
        </section>
      </section>

      <Footer />
    </>
  );
};

export default Ideology;
